import { useEffect, useState } from "react";
import { toast } from "react-toastify";

const COOLDOWN_SECONDS = 60;

const RequestUpdateButton = ({
    model,
    serial,
    scope,          // e.g. "fileBrowsing" | "fileToMachine"
    requestFn,      // async () => {}
    onSuccess,      // optional callback (reload data)
}) => {
    const storageKey = `${scope}_requestUpdate_${model}_${serial}`;
    const [remaining, setRemaining] = useState(0);

    /* -------- init cooldown -------- */
    useEffect(() => {
        const until = Number(localStorage.getItem(storageKey));
        if (!until) return;

        const diff = until - Date.now();
        setRemaining(diff > 0 ? Math.ceil(diff / 1000) : 0);
    }, [storageKey]);

    /* -------- countdown -------- */
    useEffect(() => {
        if (remaining <= 0) return;

        const interval = setInterval(() => {
            const until = Number(localStorage.getItem(storageKey));
            if (!until) {
                setRemaining(0);
                return;
            }

            const diff = until - Date.now();
            const next = diff > 0 ? Math.ceil(diff / 1000) : 0;
            setRemaining(next);

            if (next <= 0) {
                localStorage.removeItem(storageKey);
                clearInterval(interval);
                onSuccess?.();
            }
        }, 1000);

        return () => clearInterval(interval);
    }, [remaining, storageKey]);

    /* -------- click -------- */
    const handleClick = async () => {
        try {
            await requestFn();

            toast.success("Request sent successfully");

            const until = Date.now() + COOLDOWN_SECONDS * 1000;
            localStorage.setItem(storageKey, String(until));
            setRemaining(COOLDOWN_SECONDS);

            onSuccess?.();
        } catch (err) {
            console.error("Request update failed:", err);
            toast.error("Failed to request update");
        }
    };

    return (
        <button
            className="btn btn-download"
            onClick={handleClick}
            disabled={remaining > 0 || !model || !serial}
        >
            {remaining > 0
                ? `Request Update (${remaining}s)`
                : "Request Update"}
        </button>
    );
};

export default RequestUpdateButton;
